import { FieldErrors } from 'react-hook-form';
import { IProgramSetupForm } from 'shared/interfaces/IProgramSetup';
import { Banner } from '../ProgramSetup.styled';

interface Props {
  errors: FieldErrors<IProgramSetupForm>;
}

// Flattens the react-hook-form error tree into readable messages. Walks the full
// tree — a nested field (e.g. local_recording_details.source_folder) failing
// validation used to fail silently here, since only top-level messages were read
// and Update would just do nothing with no visible error.
const collectMessages = (errors: unknown): string[] => {
  const messages: string[] = [];
  Object.values(errors || {}).forEach((error: any) => {
    if (!error) return;
    if (typeof error.message === 'string' && error.message) {
      messages.push(error.message);
      return;
    }
    if (typeof error === 'object') {
      messages.push(...collectMessages(error));
    }
  });
  return messages;
};

export const ErrorBanner = ({ errors }: Props) => {
  const messages = collectMessages(errors);
  if (messages.length === 0) return null;

  return (
    <Banner>
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <circle cx="12" cy="12" r="10" />
        <path d="M12 7v6M12 16.5v.5" />
      </svg>
      <div>
        <b>Fix these before updating</b>
        <ul>
          {messages.map((message) => (
            <li key={message}>{message}</li>
          ))}
        </ul>
      </div>
    </Banner>
  );
};
